<template>
  <section id="keyboard" ref="keyboard">
    <div class="keyboard-numbers">
      <div
        class="keyboard-row"
        v-for="(keyRow, rowIndex) in keys"
        :key="rowIndex"
      >
        <button
          class="keyboard-key"
          v-for="key in keyRow"
          :key="key"
          :disabled="disabled"
          :aria-label="'add ' + key"
          @click="emitValue(key)"
        >
          {{ key }}
        </button>
      </div>
    </div>
    <button
      class="keyboard-delete"
      :disabled="disabled"
      @click="emitValue('Backspace')"
      aria-label="backspace"
    >
      <svg
        width="100%"
        height="100%"
        viewBox="0 0 54 54"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink"
        xml:space="preserve"
        xmlns:serif="http://www.serif.com/"
        class="key-icons"
        title="Backspace"
        alt="Arrow Pointing Left"
        :class="{ flipped: reverseFill }"
        style="
          fill-rule: evenodd;
          clip-rule: evenodd;
          stroke-linejoin: round;
          stroke-miterlimit: 2;
          fill: var(--background-color);
        "
      >
        <path
          d="M-0,27.009l18.018,-18.018l35.982,-0l0,36.018l-36,0l-18,-18Zm5.303,0l14.25,14.25l30.697,0l0,-28.518l-30.678,-0l-14.269,14.268Z"
        />
        <path
          d="M30.979,27l-6.86,-6.86c-0.732,-0.732 -0.732,-1.92 -0,-2.652c0.732,-0.732 1.92,-0.732 2.651,0l6.861,6.86l6.86,-6.86c0.732,-0.732 1.92,-0.732 2.651,0c0.732,0.732 0.732,1.92 0,2.652l-6.86,6.86l6.86,6.86c0.732,0.732 0.732,1.92 0,2.652c-0.731,0.732 -1.919,0.732 -2.651,-0l-6.86,-6.86l-6.861,6.86c-0.731,0.732 -1.919,0.732 -2.651,-0c-0.732,-0.732 -0.732,-1.92 -0,-2.652l6.86,-6.86Z"
        />
      </svg>
    </button>
  </section>
</template>

<script>
export default {
  name: "KnotBoard",
  props: {
    keys: Object,
    canSubmit: Boolean,
    disabled: Boolean,
    reverseFill: Boolean,
  },
  computed: {
    isVisible() {
      return this.keys.length > 0;
    },
  },
  methods: {
    emitValue(keyValue) {
      this.$emit("key-pushed", keyValue);
    },
  },
  mounted() {},
};
</script>

<style scoped>
.keyboard-numbers {
  display: flex;
  flex-direction: column;
  row-gap: var(--key-spacing);
  justify-items: stretch;
  align-items: stretch;
  overflow: hidden;
  flex: 2 1 auto;
}
.keyboard-delete {
  width: 20%;
}
#keyboard {
  display: flex;
  flex-direction: row;
  column-gap: var(--key-spacing);
  justify-items: stretch;
  align-items: stretch;
  overflow: hidden;
  position: absolute;
  width: 100%;
  height: 100%;
}

.keyboard-row {
  display: flex;
  column-gap: var(--key-spacing);
  justify-content: center;
  flex: 1 0 auto;
}

.keyboard-key:enabled:active {
  filter: brightness(90%);
}
.keyboard-key.empty {
  font-size: 0em;
}
.keyboard-key {
  transition: all 0.125s cubic-bezier(0.94, 0.77, 0.57, 1.25); /* Smooth transition */
  touch-action: manipulation;
  display: flex;
  flex: 1 1 25%;
  font-size: 2.75vh;
}

.large {
  flex: 1;
}
.submit {
  font-size: 0.675em;
}

.key-icons {
  width: 4vh;
}

.keyboard-enter-active,
.keyboard-leave-active {
  transition: all 5s cubic-bezier(0.94, 0.77, 0.57, 1.25);
}
.keyboard-enter-from .keyboard-key,
.keyboard-leave-to .keyboard-key {
  font-size: 0;
  height: 0px;
  width: 0px;
}
button {
  font-size: 2.75vh;
}
</style>
